import {gsap} from "../LibrariesImport";
export default class BlockScrollingTextImage {
	static init() {

		document.querySelectorAll(".block-scrolling-text-image").forEach(block => {

			const scrollingLines = block.querySelectorAll(' .scrolling-text');
			scrollingLines.forEach( (line, index) => {
				const scrollingText = line.querySelectorAll(' .text');
				const direction = index % 2 === 0 ? -200 : 200;

				const width = line.offsetWidth;
				const multiplier = window.innerWidth > 767 ? 40 : 70;

				setTimeout(() => {
					gsap.to(scrollingText, {
						xPercent: direction,
						duration: (width / window.innerWidth) * multiplier,
						ease: "linear",
						repeat: -1
					});
				});
			});

			const container = block;
			const containerImages = block.querySelector('.images');
			const images = containerImages.querySelectorAll('img');
			const labels = block.querySelectorAll('.label');

			const quickX = gsap.quickTo(containerImages, "x", { duration: 0.3, ease: "power2.out" });
			const quickY = gsap.quickTo(containerImages, "y", { duration: 0.3, ease: "power2.out" });
			const quickRotate = gsap.quickTo(containerImages, "rotation", { duration: 0.3, ease: "power2.out" });

			let lastX = 0, lastY = 0;

			container.addEventListener("mousemove", (event) => {
				const { left, top } = container.getBoundingClientRect(); // Position du parent
				const rect = containerImages.getBoundingClientRect(); // Taille du follower
				const offsetX = rect.width / 2;
				const offsetY = rect.height / 2;

				// Calcul des positions relatives
				const relativeX = event.clientX - left - offsetX;
				const relativeY = event.clientY - top - offsetY;

				// Calcul de l'angle de rotation en fonction du déplacement
				const deltaX = relativeX - lastX;
				// const deltaY = relativeY - lastY;
				const angle = deltaX * 0.15; // Ajuste la sensibilité de l'inclinaison

				// Mise à jour des valeurs stockées
				lastX = relativeX;
				lastY = relativeY;

				// Appliquer les animations
				quickX(relativeX);
				quickY(relativeY);
				quickRotate(angle); // Appliquer l'inclinaison
			});

			labels.forEach( (item, i) => {
				item.addEventListener( 'mouseenter', () => {
					containerImages.classList.add('reveal');
					images.forEach((img) => {
						img.classList.remove('reveal');
					});
					images[ item.dataset.id ].classList.add('reveal');
				});
			});

			container.addEventListener("mouseleave", () => {
				containerImages.classList.remove('reveal');
			});


		});

	}

}
